import React from 'react';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { StyledPageSubTitle, StyledPageTitle } from 'theme/styles';
import { FormRadioGroup } from 'components/molecules/FormRadioGroup';
import Button from 'components/atoms/Button';
import { EButtonVariants } from 'constants/Buttons';
import { LoginType } from 'models/auth';

interface ITwoFactorChoosePage {
  onSubmit: (twoFactorMethod: LoginType) => void;
  changePage: (p: number) => void;
}

const TwoFactorChoosePage = ({ onSubmit, changePage }: ITwoFactorChoosePage) => {
  const { t } = useTranslation();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: { authenticationMethod: LoginType.Sms },
  });

  const onSubmitForm = (data: any) => {
    onSubmit(data.authenticationMethod);
  };

  return (
    <>
      <Grid item container xs={12} gap={7}>
        <Grid item container xs={12} gap={1}>
          <Grid item xs={12}>
            <StyledPageTitle variant="h4">{t('page.signin.choose.title')}</StyledPageTitle>
          </Grid>
          <Grid item xs={12}>
            <StyledPageSubTitle variant="body2">
              {t('page.signin.choose.subtitle')}
            </StyledPageSubTitle>
          </Grid>
        </Grid>
      </Grid>
      <form onSubmit={handleSubmit(onSubmitForm)}>
        <FormRadioGroup
          name="authenticationMethod"
          label="Choose the two factor authentication method"
          options={[
            { label: 'One-time code via SMS', value: LoginType.Sms },
            { label: 'One-time code via email', value: LoginType.Email },
          ]}
          control={control}
          errors={errors}
        />

        <Grid item container xs={12} gap={1.3} justifyItems="center">
          <Grid item xs={12}>
            <Button
              id="login"
              type="submit"
              label={t('page.signin.choose.button.next')}
              variant={EButtonVariants.contained}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              id="signin"
              label={t('page.signin.choose.button.back')}
              variant={EButtonVariants.outlined}
              fullWidth
              onClick={() => changePage(1)}
            />
          </Grid>
        </Grid>
      </form>
    </>
  );
};

export default TwoFactorChoosePage;
